<template>
    <div>
        <br/>
        <h3 class="text-center">ใบส่งของให้แก่ลูกค้ารายย่อย</h3>
        <br/>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label
                           text-capitalize text-right">วันที่</label>
                    <div class="col-sm-8">
                        <input class="form-control"
                               v-model="form.date"
                               disabled/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label
                           text-capitalize text-right">ร้าน / ชื่อลูกค้า</label>
                    <div class="col-sm-8">
                        <template v-if="form.customer_other">
                            <input class="form-control" v-model="form.customer_other.store_name"
                                   :disabled="form.customer_other_id"/>
                        </template>
                        <template v-else>
                            <input class="form-control" v-model="customer_name"/>
                        </template>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label
                           text-capitalize text-right">ที่อยู่</label>
                    <div class="col-sm-8">
                        <template v-if="form.customer_other">
                            <input class="form-control" v-model="form.customer_other.address"/>
                        </template>
                        <template v-else>
                            <input class="form-control" v-model="customer_address"/>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label
                           text-capitalize text-right">เลขที่ใบบิล</label>
                    <div class="col-sm-8">
                        <input class="form-control" v-model="form.invoice_id" disabled/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label
                           text-capitalize text-right">+โฟม</label>
                    <div class="col-sm-8">
                        <b-form-select v-model="form.other_price_form"
                                       @input="calculatePromotionArray"
                                       class="w-50"
                                       :options="price_product">
                        </b-form-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>
                        <input type="checkbox" v-model="selectAll"/>
                    </th>
                    <th>รหัสสินค้า</th>
                    <th>ชื่อสินค้า</th>
                    <th>จำนวนที่มีในใบบิล</th>
                    <th>จำนวนที่ต้องการส่ง</th>
                    <th>ราคาบวกบาท (เบ็ดเตล็ด)</th>
                    <th>ราคาต่อแพ็ค</th>
                    <th>ราคารวม</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="detail in form.details">
                    <template v-if="detail.product">
                        <td><input type="checkbox"
                                   :value="detail"
                                   :disabled="!detail.product"
                                   v-model="checked"/></td>
                        <td>
                            <template v-if="detail.product">
                                {{ detail.product.sku }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="detail.product">
                                {{ detail.product.name }}
                            </template>
                            <template v-else><span style="color: red">รายการสินค้านี้ถูกลบจากคลังสินค้าแล้ว</span>
                            </template>
                        </td>
                        <td>
                            {{ detail.quantity }}
                        </td>
                        <td align="center">
                            <input type="number"
                                   v-model="detail.remaining"
                                   class="form-control"/>
                        </td>
                        <td align="center">
                            <input type="number"
                                   :disabled="detail.product.product_type_id == 1"
                                   @input="calculatePromotionArray"
                                   v-model="detail.other_price"
                                   class="form-control"/>
                        </td>
                        <td>
                            {{ parseFloat(detail.price) + parseFloat(detail.other_price_total) | currency }}
                        </td>
                        <td>{{ detail.total | currency }}</td>
                    </template>
                </tr>
                <tr style="font-weight: bold">
                    <td colspan="6" class="text-right">รวม</td>
                    <td colspan="2" class="text-right">{{ calculateTotalFromDetails | currency }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-row>
            <div class="col text-center">
                <button
                    type="button"
                    @click="PrintFormInvoice"
                    class="btn btn-success">
                    <icon name="print" style="width: 25px"></icon>
                    บันทึกและพิมพ์
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    @click="cancelSubmit"
                    class="btn btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-row>
        <!--<pre class="alert-success">{{form.details}}</pre>-->
        <!--<pre class="alert-secondary">{{checked}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "print-form-invoice-modal",
    data() {
        return {
            type_form: 1,
            checked: [],
            select_all: false,
            customer_name: "",
            customer_address: "",
            price_product: [
                {value: null, text: "ไม่มีราคา"},
                {value: 1, text: "+1"},
                {value: 2, text: "+2"},
                {value: 3, text: "+3"},
                {value: 4, text: "+4"},
                {value: 5, text: "+5"},
                {value: 6, text: "+6"},
                {value: 7, text: "+7"},
                {value: 8, text: "+8"},
                {value: 9, text: "+9"},
                {value: 10, text: "+10"},
            ],
            details: [],
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Invoice.invoiceForm;
            },
        }),
        calculateTotalFromDetails() {
            return this.checked.reduce((carry, detail) => {
                return carry + detail.total;
            }, 0);
        },
        selectAll: {
            get: function () {
                return this.form.details ? this.checked.length === this.form.details.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    this.checked = this.form.details;
                } else {
                    this.select_all = false;
                    this.checked = [];
                }
            }
        },
    },
    methods: {
        checkedValue() {
            this.validate = true;
            if (this.checked.length > 0) {
                this.checked.forEach(data => {
                    if (data.remaining > data.quantity || !data.remaining) {
                        return this.validate = false;
                    }
                })
            } else {
                this.validate = false;
            }
        },
        PrintFormInvoice() {
            this.checkedValue();
            if (this.checked.length < 1) {
                alert("กรุณาเลือกรายการที่ต้องการส่งให้ลูกค้ารายย่อย");
            } else if (!this.validate) {
                alert("กรุณาใส่จำนวนที่ต้องการส่งให้ถูกต้อง")
            } else {
                let address = "";
                let customer_name = "";
                if (this.form.customer_other) {
                    address = this.form.customer_other.address;
                    customer_name = this.form.customer_other.store_name;
                } else {
                    address = this.customer_address;
                    customer_name = this.customer_name;
                }
                this.checked.forEach(detail => {
                    let info = {
                        invoice_detail_id: detail.id,
                        quantity: detail.quantity,
                        other_price_total: detail.other_price_total
                    };
                    this.details.push(info)
                });
                let data = {
                    invoice_id: this.form.id,
                    date: this.form.date,
                    address: address,
                    name: customer_name,
                    details: this.details,
                };
                //console.log(data);
                this.$emit("submit", data);
                this.checked = [];
                this.details = [];
            }
        },
        calculatePromotionArray() {
            //console.log('promotion');
            let data = {
                other_price_form: this.form.other_price_form,
                details: this.form.details
            };
            this.$store.dispatch("Invoice/promotionInvoiceMultiple", data).then(() => {
                this.checked = this.form.details;
            });
        },
        cancelSubmit() {
            this.$emit("submit", 0);
        },
    }
}
</script>

<style scoped>
table, tr, td {
    background-color: white;
    color: black;
}
</style>
